import { render, staticRenderFns } from "./People.vue?vue&type=template&id=db586c56&scoped=true&"
import script from "./People.vue?vue&type=script&lang=ts&"
export * from "./People.vue?vue&type=script&lang=ts&"
import style0 from "./People.vue?vue&type=style&index=0&id=db586c56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db586c56",
  null
  
)

export default component.exports